
import { mapGetters, mapActions, mapMutations } from 'vuex'
import FilterColor from '.././filter-color'
import FilterSize from '.././filter-size'
import FilterPrices from '.././filter-prices'
import FilterCheckbox from '.././filter-checkbox'
import FilterListItem from './filterListItem.vue'
import ActiveFilterToggle from './activeFilterToggle.vue'
import SortBy from './sortyBy.vue'
import Backdrop from '~/components/common/backdrop'

export default {
  components: {
    Backdrop,
    FilterListItem,
    ActiveFilterToggle,
    SortBy,
    FilterColor,
    FilterSize,
    FilterPrices,
    FilterCheckbox,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    filterFacets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      wording: null,
    }
  },
  computed: {
    ...mapGetters({
      vxSearchFilters: 'search/getSearchFilters',
      vxSearchResults: 'search/getSearchResults',
      vxStoryContent: 'search/getStoryContent',
    }),
    totalResults() {
      return this.vxSearchResults.pagination.totalResults
    },
    priceFacets() {
      return this?.filterFacets?.find(({ field }) => field === 'ss_final_price')
        ?.values
    },
  },
  watch: {
    isOpen(val) {
      document.body.style.overflow = val ? 'hidden' : 'auto'
    },
  },
  methods: {
    ...mapActions({
      vxResetAllSearch: 'search/resetAllSearch',
    }),
    ...mapMutations({
      vxResetSearchResults: 'search/resetSearchResults',
    }),
    getActiveFiltersCount(facet) {
      return facet.values.filter((item) => item.active).length
    },
    doFilterReset() {
      this.vxResetSearchResults('filtering')
      this.vxResetAllSearch()
    },
  },
}
